import { Init as QuickMenuInit } from './_quickmenu';

/**
 * Initializes the QuickMenu functionality
 * Note: This now includes enhanced Back to Top functionality
 */
function initializeQuickMenu() {
  // Check if the QuickMenu HTML structure is present on the page
  if (document.querySelectorAll('.quickmenu').length > 0) {
    QuickMenuInit();
  } else {
    // console.log('QuickMenu element (.quickmenu) not found on this page.');
  }
}

// Wait for the DOM to be fully loaded before initializing
if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', initializeQuickMenu);
} else {
  // `DOMContentLoaded` has already fired
  initializeQuickMenu();
}

// Export the original Init function
export default QuickMenuInit;
